export const WEB_BEHAVIORS = {
  SYSTEM_MAINTAIN_MAINTAIN: '当前组织维护下级组织(有发生实际运维)',
  SYSTEM_MAINTAIN_MAINTAINED: '当前组织被上级组织维护',
  SYSTEM_MAINTAIN_ENTER_MAINTAIN: '当前组织点击维护下级组织',
  SYSTEM_MAINTAIN_ENTER_SELF_MAINTAIN: '当前组织点击维护自身组织',
  REVERT_PASSWORD: 'web用户登录前找回密码',
  UPDATE_PASSWORD: 'web用户登录后修改密码',
  UPATE_BASIC_INFO: '修改基础信息(邮箱、组织信息)',
  FORBID_PASSWORD_LOGIN: '登录时检测到禁止密码登录',
  LOCK_PASSWORD_LOGIN: '登录密码错误被锁定',
  LEAVE_ORG: '有内部成员退出组织',
  JOIN_ORG: '有内部成员加入组织',
  JOIN_ORG_BY_INVITE_URL: '成员通过需审核的邀请链接加入组织',
  JOIN_ORG_BY_INVITE_URL_WITHOUT_AUDIT: '成员通过无需审核的邀请链接加入组织',
  TERMINAL_CACHE_REVERT: '用户点击离线终端还原云桌面',
  TERMINAL_USER_RESET_PASSWORD: '重置终端用户密码',
  OPENAPI_RESET_APP_SECRET: '使用openApi时重置对接应用秘钥'
}
